export interface ETFsResponse {
  etfs: ETF[];
  total: number;
}

export interface ETF {
  id: number;
  name: string;
  slug: string;
  url: string;
  description: string;
  etf_logo: string;
  total_aum_for_etf: string;
  avg_expense_ratio: string;
  total_aum: number;
  num_funds: number;
  funds: Fund[];
}

export interface Fund {
  id: number;
  name: string;
  slug: string;
  avg_expense_ratio: string;
  fund_etf_count: null;
  fund_aum: number;
  investment_style: string;
  management_fee: number;
  qm_fund_score: number;
  number_of_stock_holdingnet: number;
  number_of_bond_holdingnet: string;
  total_number_holding: number;
  managers: string[];
  marketcapital: string;
  inception_date: string;
  price_to_earning: number;
  price_to_book: number;
  equity_sector_allocation: EquitySectorAllocation[];
  fund_top_holders: FundTopHolder[];
  top_holder_snapshotdate?: string;
  region: string;
  inflows: null;
  avg_daily_volume: string | null;
  total_shares: null;
  fund_custom_field_value: null;
  fund_custom_field_label: null;
  fund_logo: null;
  fund_symbol: string;
  issuer_website: null;
  fund_description: string;
  avg_vol_30days: number;
  beta: number;
  shares_outstanding: number;
  dividend: Dividend;
  fund_category: FundCategory[];
}

export interface Dividend {
  date: string;
  amount: number;
  yield: number;
  latestamount: LatestAmount;
  frequency: DividendFrequency;
  paydate: Date;
  declaredDate: Date;
}

type DividendFrequency = 'A' | 'M' | 'Q' | 'R';

// A = Annual
// M = Monthly
// Q = Quarterly
// R = other regular

export interface FundCategory {
  category: string;
  definition: string;
}

export interface EquitySectorAllocation {
  name: string;
  percent: string;
}

export interface FundsResponse {
  funds: Fund[];
  total: number;
}

export interface LatestAmount {
  currency: string;
  content: number;
}

export enum AvgExpenseRatio {
  The067875 = '0.67875%',
  The075 = '0.75%',
  The09275 = '0.9275%',
  The1395 = '1.395%',
}

export interface FundTopHolder {
  symbol: string;
  name: string;
  sharepercentage: number;
}
